import React from "react";
import ajax from "./../../lib/ajax.js";
import context from "./../../lib/context.js";
import moment from "moment";
import {browserHistory} from "react-router";

export default class CreateSummaryForm extends React.Component {
    constructor(props) {
        super(props);
        
    }

    componentDidMount() {

    }

    render() {
        const vm = this.props.vm;
        let btnSubmit = null;
        return(            
            <div className="container-fluid">
                <div className="row">
                    <div className="col-md-12 col-lg-12">
                        <h2 className="text-center ap-title">Delegate Added Confirmation</h2>
                        <h3 className="text-center ap-sub-title">Congratulations your delegation has been completed successfully.</h3>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-12 col-lg-12">
                        An email will be sent shortly to your delegate notifying them that they will be authorized to sign Web Timecards in your absence.
                        <ul>
                            <li>Delegate&quot;s name: <b>{vm.firstName} {vm.lastName}</b></li>
                            <li>Delegate&quot;s email address: <b>{vm.email}</b></li>
                            <li>Delegation is effective: <b>{moment(vm.startDate).format("MM/DD/YYYY")} - {moment(vm.endDate).format("MM/DD/YYYY")}</b></li>
                        </ul>
                        NOTE: If your delegate does not receive authorization email, they can go to <a href="http://action.ain1.com">http://action.ain1.com</a>. and log into the Action Portal
                    </div>
                </div>
            </div>);
    }
}